export enum FileWriteEvents {
  SYNC_PATIENTS = 'sync-patients',
  OPEN_PATIENT_IN_MEDFLEX = 'open-patient-in-medflex',
}

export enum GdtFeatures {
  SYNC_PATIENTS = 'syncPatients',
  OPEN_PATIENT_IN_PVS = 'openPatientInPVS',
  OPEN_PATIENT_IN_MEDFLEX = 'openPatientInMedflex',
  WRITE_EXAMINATION = 'writeExamination',
}

export enum PvsSelectOptions {
  MEDICAL_OFFICE = 'MEDICAL_OFFICE',
  MEDISTAR = 'MEDISTAR',
  T2MED = 'T2MED',
  MEDATIXX = 'MEDATIXX',
}

export enum IpcResponses {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum FileSources {
  PAM = 'PAM',
  CONTACT = 'CONTACT',
  SESSION = 'SESSION',
}
